module.exports = __webpack_public_path__ + "static/media/pydata-logo-banner.984bd38c.png";